import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  accordion: {
    '& ..MuiAccordion-root.Mui-expanded': {
      margin: 0,
    },
    '& .icon-expanded': {
      fill: Theme.palette.primary.light,
      width: 24,
      height: 24,
      [Theme.breakpoints.up('md')]: {
        width: 34,
        height: 34,
      },
    },
    '& .MuiAccordionDetails-root': {
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      paddingTop: 16,
      [Theme.breakpoints.up('md')]: {
        padding: 24,
      },
    },
    '& .MuiAccordionSummary-root': {
      boxShadow: 'none',
      padding: 16,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    background: Theme.palette.gray[100],
    padding: '16px 24px',
    gap: 24,
    [Theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    '& .cancel-warning': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '24px',
      color: Theme.palette.warning.main,
      marginRight: 'auto',
      [Theme.breakpoints.down('sm')]: {
        marginRight: '0',
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
      '& p': {
        margin: '0',
        color: Theme.palette.gray[750],
        fontSize: Theme.typography.size[1.5],
        lineHeight: '24px',
        [Theme.breakpoints.down('sm')]: {
          width: '100%',
          fontSize: Theme.typography.size[0.5],
        },
      },
      '& span': {
        display: 'flex',
        marginRight: '8px',
        color: Theme.palette.warning.main,
        fontSize: Theme.typography.size[1.5],
        lineHeight: '24px',
        [Theme.breakpoints.down('sm')]: {
          width: '100%',
          fontSize: Theme.typography.size[0.5],
          marginBottom: '4px',
        },
      },
      '& a': {
        marginLeft: '4px',
        color: Theme.palette.primary.light,
      },
    },
    '& .MuiButton-root': {
      whiteSpace: 'nowrap',
    },
    '& .button-text': {
      padding: '12px  0',
      [Theme.breakpoints.down('sm')]: {
        padding: '0',
        height: '26px',
      },
    },
  },
  detailsWrapper: {
    width: '100%',

    '& >div:nth-child(1)': {
      paddingBottom: 16,
    },
    '& >div:nth-child(2)': {
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      paddingTop: 16,
    },
  },
}));

export default useStyles;
